/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {get} from './api-calls';
import {IHashDto} from '../dtos/IHashDto';

export const getHmacHash = (): Promise<IHashDto> => {
  return get(`/intercom/identityhash?Platform=web&FromId=true`);
};
